'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOverflowCount", {
    enumerable: true,
    get: function() {
        return useOverflowCount;
    }
});
const _overflowContext = require("./overflowContext");
const useOverflowCount = ()=>(0, _overflowContext.useOverflowContext)((v)=>{
        return Object.entries(v.itemVisibility).reduce((acc, [id, visible])=>{
            if (!visible) {
                acc++;
            }
            return acc;
        }, 0);
    });
